<template>
    <!-- Ionic modal provides --max-height -->
    <div class="pt-4 pb-(--beyond-safe-area-inset-bottom) h-(--max-height) flex flex-col">
        <IonHeader
            class="ion-no-border"
            data-cy="view-modal"
        >
            <ModalHeader @close="onCancelled">
                Choose view
            </ModalHeader>
        </IonHeader>
        <IonContent>
            <DForm class="p-4">
                <DField>
                    <DRadio
                        v-for="view in views"
                        :key="`view-${view.value}`"
                        v-model="selectedValue"
                        :icon="view.icon"
                        card
                        radio-position="right"
                        :native-value="view.value"
                    >
                        <template #icon>
                            <DAvatar
                                v-if="view.icon"
                                type="icon"
                                :icon="view.icon"
                                size="10"
                            />
                        </template>
                        {{ view.label }}
                    </DRadio>
                </DField>
            </DForm>
        </IonContent>
    </div>
</template>
<script setup>
    import {
        DForm, DField, DRadio, DAvatar,
    } from '@digistorm/spark'
    import { useCalendarHelpers } from '@/composables/calendarHelpers'
    import ModalHeader from '@/components/ui/ModalHeader.vue'

    const props = defineProps({
        currentView: String,
        supportedViews: Array,
        onSelected: Function,
        onCancelled: Function,
    })
    const calendarHelpers = useCalendarHelpers()
    const {
        VIEW_MONTH,
        VIEW_WEEK,
        VIEW_DAY,
    } = calendarHelpers
    const views = computed(() => {
        const result = []
        if (props.supportedViews.includes(VIEW_MONTH)) {
            result.push({
                label: 'Month',
                value: VIEW_MONTH,
                icon: 'ph:calendar-dots',
            })
        }
        if (props.supportedViews.includes(VIEW_WEEK)) {
            result.push({
                label: 'Week',
                value: VIEW_WEEK,
                icon: 'ph:rows',
            })
        }
        if (props.supportedViews.includes(VIEW_DAY)) {
            result.push({
                label: 'Day',
                value: VIEW_DAY,
                icon: 'ph:calendar',
            })
        }
        return result
    })
    const selectedValue = ref(props.currentView)
    watch(() => selectedValue.value, (view) => {
        props.onSelected(view)
    })
</script>
